import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'fe-types-car',
    templateUrl: './types-car.component.html',
    styleUrls: ['./types-car.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class TypesCarComponent implements OnInit {
    isEnglish = false;
    constructor(private router: Router) {}

    ngOnInit(): void {
        this.isEnglish = this.router.url.startsWith('/en/');
    }
}
